(function () {
  /** Utility shorthand with scoping */
  function getScopeRoot() {
    const upsellWrapper = document.querySelector('#upsell-products-wrapper');
    if (upsellWrapper) {
      const productForm = upsellWrapper.closest('.product-form') || upsellWrapper.closest('form');
      if (productForm) {
        console.log('Found scoped product form:', productForm);
        return productForm;
      }
    }
    console.warn('Could not find scope root, falling back to document');
    return document;
  }
  
  const qs = (selector, scope = null) => {
    const searchScope = scope || getScopeRoot();
    return searchScope.querySelector(selector);
  };

  const qsa = (selector, scope = null) => {
    const searchScope = scope || getScopeRoot();
    return searchScope.querySelectorAll(selector);
  };

  // Initialize selected upsells array
  if (!window.selectedUpsells) {
    window.selectedUpsells = [];
  }

  // Get storage key for upsells (simpler than thread type system)
  function getStorageKey() {
    const productId = window.product?.id || 'unknown';
    return `selectedUpsells_${productId}`;
  }

  /*** Storage & UI updates ***/
  function loadFromStorage() {
    try {
      const storageKey = getStorageKey();
      const data = localStorage.getItem(storageKey);
      console.log(`Loading upsells from key: ${storageKey}`);
      
      if (data) {
        const parsed = JSON.parse(data);
        if (Array.isArray(parsed)) {
          window.selectedUpsells = parsed.filter(item => 
            item && 
            typeof item === 'object' && 
            item.productId
          );
          console.log(`Loaded ${window.selectedUpsells.length} upsells`);
        } else {
          window.selectedUpsells = [];
        }
      } else {
        window.selectedUpsells = [];
        console.log('No saved upsells found');
      }
    } catch (e) {
      console.error('Error loading from storage:', e);
      window.selectedUpsells = [];
      const storageKey = getStorageKey();
      localStorage.removeItem(storageKey);
    }
  }

  function saveToStorage() {
    try {
      const storageKey = getStorageKey();
      localStorage.setItem(storageKey, JSON.stringify(window.selectedUpsells));
      console.log(`Saved ${window.selectedUpsells.length} upsells to key: ${storageKey}`);
    } catch (e) {
      console.error('Error saving to storage:', e);
    }
  }

  function updateTotalCountDisplay() {
    const baseQuantity = parseInt(qs('.quantity-selector__input')?.value || '1', 10);
    const upsellsQuantity = window.selectedUpsells ? window.selectedUpsells.length : 0;
    const totalCount = baseQuantity + upsellsQuantity;
    
    const display = qs('#total-count');
    if (display) {
      display.textContent = totalCount;
      console.log('Updated count display - Base:', baseQuantity, 'Upsells:', upsellsQuantity, 'Total:', totalCount);
    }
  }

  function updateUpsellCardStates() {
    console.log('Updating upsell card states');
    
    const noneCard = qs('#none-upsell-card');
    const allProductCards = qsa('.upsell-card:not(#none-upsell-card)');
    
    // If no upsells selected, show "none" card as selected
    if (window.selectedUpsells.length === 0) {
      if (noneCard) {
        noneCard.classList.add('selected');
        noneCard.setAttribute('data-selected', 'true');
        // Force repaint for iOS
        forceRepaint(noneCard);
      }
      
      // Ensure all product cards are unselected
      allProductCards.forEach(card => {
        card.classList.remove('selected');
        card.setAttribute('data-selected', 'false');
        // Force repaint for iOS
        forceRepaint(card);
      });
    } else {
      // Upsells are selected, so "none" card should not be selected
      if (noneCard) {
        noneCard.classList.remove('selected');
        noneCard.setAttribute('data-selected', 'false');
        // Force repaint for iOS
        forceRepaint(noneCard);
      }
      
      // Reset all product cards to unselected first
      allProductCards.forEach(card => {
        card.classList.remove('selected');
        card.setAttribute('data-selected', 'false');
        // Force repaint for iOS
        forceRepaint(card);
      });

      // Mark selected product cards
      window.selectedUpsells.forEach(upsell => {
        const card = qs(`[data-upsell-product-id="${upsell.productId}"]`);
        if (card && card.id !== 'none-upsell-card') {
          card.classList.add('selected');
          card.setAttribute('data-selected', 'true');
          // Force repaint for iOS
          forceRepaint(card);
          console.log('Marked card as selected:', upsell.productId);
        }
      });
    }
  }
  
  // Force browser repaint to fix iOS rendering issues
  function forceRepaint(element) {
    if (element) {
      // Simpler method - just trigger reflow by reading offsetHeight
      // This is less visually disruptive than the transform method
      void element.offsetHeight;
    }
  }

  /*** Toggle Functionality ***/
  function wireUpsellCards() {
    const cards = qsa('.upsell-card');
    cards.forEach(card => {
      // Remove existing listeners to prevent duplicates
      card.removeEventListener('click', handleUpsellCardClick);
      card.addEventListener('click', handleUpsellCardClick);
    });
    
    // Wire variant dropdowns
    wireUpsellVariantDropdowns();
  }
  
  function wireUpsellVariantDropdowns() {
    // Get all upsell cards with variants
    const cardsWithVariants = document.querySelectorAll('.upsell-card .uc-options');
    
    console.log('=== WIRING VARIANT DROPDOWNS ===');
    console.log('Found', cardsWithVariants.length, 'cards with variants');
    
    cardsWithVariants.forEach((optionsContainer, containerIndex) => {
      const card = optionsContainer.closest('.upsell-card');
      const productId = card.getAttribute('data-upsell-product-id');
      
      console.log(`Processing card ${containerIndex + 1}, product ID:`, productId);
      
      // Get variant data
      const variantDataScript = optionsContainer.querySelector(`.upsell-product-variants[data-product-id="${productId}"]`);
      if (!variantDataScript) {
        console.error('No variant data script found for product:', productId);
        return;
      }
      
      let variants;
      try {
        variants = JSON.parse(variantDataScript.textContent);
        console.log(`Product ${productId} has ${variants.length} variants`);
      } catch (e) {
        console.error('Failed to parse variant data for product:', productId, e);
        return;
      }
      
      // Wire each option dropdown
      const optionGroups = optionsContainer.querySelectorAll('.uc-option-group');
      console.log(`Product ${productId} has ${optionGroups.length} option groups`);
      
      optionGroups.forEach((group, index) => {
        const wrapper = group.querySelector('.variant-select-wrapper');
        const toggleButton = wrapper.querySelector('.upsell-variant-toggle-button');
        const optionPosition = parseInt(toggleButton.getAttribute('data-option-position'));
        const label = wrapper.querySelector(`[id^="upsell-option-selected-${productId}"]`);
        const optionList = wrapper.querySelector('.combo-box__option-list');

        if (!toggleButton || !label || !optionList) {
          console.error('Missing dropdown elements for product:', productId);
          return;
        }

        // CRITICAL: Initialize the data-selected-value attribute with the default selected option
        // We need to find which button is currently selected (aria-selected="true") or matches the label text
        if (!label.hasAttribute('data-selected-value')) {
          const currentDisplayedValue = label.textContent.trim();
          
          // Try to find the selected button by aria-selected attribute first
          let selectedButton = optionList.querySelector('button[aria-selected="true"]');
          
          // If no button is marked as selected, find by matching text content
          if (!selectedButton) {
            const allButtons = optionList.querySelectorAll('button');
            for (const btn of allButtons) {
              if (btn.textContent.trim() === currentDisplayedValue) {
                selectedButton = btn;
                break;
              }
            }
          }
          
          if (selectedButton) {
            // Get the data-option-value from the selected button
            // This will have the correct value even if it contains quotes
            const correctValue = selectedButton.getAttribute('data-option-value');
            label.setAttribute('data-selected-value', correctValue);
            console.log(`Initialized default option for product ${productId}:`, correctValue);
          } else {
            console.error(`Could not find selected button for product ${productId}, displayed value: "${currentDisplayedValue}"`);
          }
        }

        // Remove existing listeners
        toggleButton.removeEventListener('click', toggleButton._clickHandler);
        
        // Toggle dropdown
        toggleButton._clickHandler = (e) => {
          e.stopPropagation();
          const isOpen = optionList.style.display === 'block';
          
          // Close all dropdowns
          document.querySelectorAll('.upsell-variant-options').forEach(list => {
            list.style.display = 'none';
          });
          document.querySelectorAll('.upsell-variant-toggle-button').forEach(btn => {
            btn.setAttribute('aria-expanded', 'false');
          });
          
          optionList.style.display = isOpen ? 'none' : 'block';
          toggleButton.setAttribute('aria-expanded', String(!isOpen));
        };
        toggleButton.addEventListener('click', toggleButton._clickHandler);

        // Handle option selections
        optionList.querySelectorAll('button').forEach(button => {
          button.removeEventListener('click', button._clickHandler);
          
          button._clickHandler = (e) => {
            e.stopPropagation();
            const selectedValue = button.getAttribute('data-option-value');
            const optionPosition = button.getAttribute('data-option-position');
            
            console.log(`Option selected for product ${productId}:`, selectedValue);
            
            // Update this dropdown
            label.textContent = selectedValue;
            optionList.querySelectorAll('button').forEach(opt => opt.setAttribute('aria-selected', 'false'));
            button.setAttribute('aria-selected', 'true');
            optionList.style.display = 'none';
            toggleButton.setAttribute('aria-expanded', 'false');
            
            // CRITICAL FIX: Store the exact data-option-value on the label
            // This ensures we match exactly what's in the variant data
            label.setAttribute('data-selected-value', selectedValue);
            
            // Get currently selected options - use data attributes ONLY
            const selectedOptions = [];
            optionsContainer.querySelectorAll('.select__selected-value').forEach(valueSpan => {
              // CRITICAL: Always use the data attribute, never text content
              // Text content can have whitespace issues or be truncated
              const value = valueSpan.getAttribute('data-selected-value');
              if (value) {
                selectedOptions.push(value);
              } else {
                console.error('Missing data-selected-value on option label:', valueSpan);
              }
            });
            
            console.log('All selected options (from data attributes):', selectedOptions);
            
            // Find matching variant
            const matchingVariant = variants.find(variant => {
              if (!variant.available) {
                return false;
              }
              
              // Check if all options match
              const matches = selectedOptions.every((optValue, idx) => {
                const variantOption = variant[`option${idx + 1}`];
                const doesMatch = variantOption === optValue;
                if (!doesMatch) {
                  console.log(`Option ${idx + 1} mismatch: variant="${variantOption}" vs selected="${optValue}"`);
                }
                return doesMatch;
              });
              
              return matches;
            });
            
            if (matchingVariant) {
              console.log('✓ Found matching variant:', {
                id: matchingVariant.id,
                title: matchingVariant.title,
                price: matchingVariant.price,
                available: matchingVariant.available
              });
              
              // Update hidden input with matched variant ID
              const hiddenInput = optionsContainer.querySelector('.upsell-variant-select');
              if (hiddenInput) {
                const oldValue = hiddenInput.value;
                hiddenInput.value = matchingVariant.id;
                console.log(`Updated hidden input from ${oldValue} to ${matchingVariant.id}`);
              } else {
                console.error('Could not find hidden input for product:', productId);
              }
              
              // Update card data attribute
              card.setAttribute('data-upsell-variant-id', matchingVariant.id);
              card.setAttribute('data-upsell-price', matchingVariant.price);
              
              // Update price display
              const priceElement = card.querySelector('.uc-price .price');
              if (priceElement && matchingVariant.price) {
                // Format price (assuming price is in cents)
                const formattedPrice = new Intl.NumberFormat('en-GB', {
                  style: 'currency',
                  currency: 'GBP'
                }).format(matchingVariant.price / 100);
                priceElement.textContent = formattedPrice;
              }
              
              // If this card is currently selected in storage, update the stored variant ID
              const existingIndex = window.selectedUpsells.findIndex(upsell => 
                upsell.productId === productId
              );
              
              if (existingIndex !== -1) {
                const oldVariantId = window.selectedUpsells[existingIndex].variantId;
                window.selectedUpsells[existingIndex].variantId = matchingVariant.id.toString();
                saveToStorage();
                console.log(`✓ Updated storage from variant ${oldVariantId} to ${matchingVariant.id}`);
              } else {
                console.log('Card not currently selected, no storage update needed');
              }
            } else {
              console.error('✗ No matching variant found for options:', selectedOptions);
              console.log('Available variants:', variants.filter(v => v.available).map(v => ({
                id: v.id,
                option1: v.option1,
                option2: v.option2,
                option3: v.option3
              })));
            }
          };
          button.addEventListener('click', button._clickHandler);
        });
      });
    });
    
    // Close dropdowns on outside click
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.variant-select-wrapper')) {
        document.querySelectorAll('.upsell-variant-options').forEach(list => {
          list.style.display = 'none';
        });
        document.querySelectorAll('.upsell-variant-toggle-button').forEach(btn => {
          btn.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  function handleUpsellCardClick(e) {
    e.preventDefault();
    
    const card = e.currentTarget;
    const productId = card.getAttribute('data-upsell-product-id');
    const title = card.getAttribute('data-upsell-title');
    
    // Get variant ID - check if there's a variant selector first
    const variantInput = card.querySelector('.upsell-variant-select');
    let variantId = variantInput ? variantInput.value : card.getAttribute('data-upsell-variant-id');
    
    const price = card.getAttribute('data-upsell-price');

    // Handle "none" card - clear all selections
    if (productId === 'none') {
      console.log('None card clicked - clearing all upsells');
      window.selectedUpsells = [];
      saveToStorage();
      updateTotalCountDisplay();
      updateUpsellCardStates();
      return;
    }

    if (!productId || !variantId) {
      console.error('Missing product data for upsell card');
      return;
    }

    // Check if this product is already selected (match by productId only, not variant)
    const existingIndex = window.selectedUpsells.findIndex(upsell => 
      upsell.productId === productId
    );

    if (existingIndex === -1) {
      // Add to selection with current variant
      const upsellData = {
        productId: productId,
        variantId: variantId,
        title: title,
        price: price
      };

      window.selectedUpsells.push(upsellData);
      console.log('Added upsell:', upsellData);
    } else {
      // Remove from selection (toggle off)
      window.selectedUpsells.splice(existingIndex, 1);
      console.log('Removed upsell:', productId);
    }

    saveToStorage();
    updateTotalCountDisplay();
    updateUpsellCardStates();
  }

  /*** Add to Cart Functionality ***/
  function addUpsellToCart() {
    // Prevent multiple simultaneous executions
    if (window.upsellCartInProgress) {
      console.log('Cart operation already in progress');
      return;
    }
    
    window.upsellCartInProgress = true;

    console.log('=== UPSELL ADD TO CART ===');

    // Get base variant ID
    let baseVariantId = qs('input[name="id"]:not([disabled])')?.value || qs('input[name="id"]')?.value;
    
    if (!baseVariantId) {
      // Try alternative selectors
      const altSelectors = [
        'select[name="id"]',
        'input[type="hidden"][name="id"]',
        '.product-form input[name="id"]'
      ];
      
      for (const selector of altSelectors) {
        const element = qs(selector);
        if (element) {
          baseVariantId = element.value;
          if (baseVariantId) {
            console.log(`Found base variant ID using selector "${selector}":`, baseVariantId);
            break;
          }
        }
      }
    }
    
    const baseQuantity = parseInt(qs('.quantity-selector__input')?.value || '1', 10);

    console.log('Base variant ID:', baseVariantId);
    console.log('Base quantity:', baseQuantity);

    if (!baseVariantId) {
      console.error('No base product variant selected');
      alert('Please select a variant for the base product');
      window.upsellCartInProgress = false;
      return;
    }

    let items = [];
    
    // Add base product
    const baseVariantIdNum = parseInt(baseVariantId);
    if (isNaN(baseVariantIdNum)) {
      console.error('Invalid base variant ID:', baseVariantId);
      alert('Invalid product selection');
      window.upsellCartInProgress = false;
      return;
    }
    
    items.push({
      id: baseVariantIdNum,
      quantity: baseQuantity
    });

    // Add selected upsells
    console.log('Adding upsells:', window.selectedUpsells);
    window.selectedUpsells.forEach((upsell, index) => {
      if (upsell.variantId) {
        const upsellVariantIdNum = parseInt(upsell.variantId);
        
        if (!isNaN(upsellVariantIdNum)) {
          items.push({
            id: upsellVariantIdNum,
            quantity: 1 // Always 1 for upsells
          });
          console.log(`Added upsell ${index}:`, upsell.title);
        } else {
          console.warn('Skipping invalid upsell variant:', upsell);
        }
      }
    });

    if (items.length === 0) {
      alert('No items to add to cart');
      window.upsellCartInProgress = false;
      return;
    }

    console.log('Final items to add:', items);

    // Disable buttons during request and save original text FIRST
    const allButtons = qsa('#AddToCart, #StickyAddToCart');
    allButtons.forEach(btn => {
      // Save original text BEFORE changing it
      if (!btn._originalText) {
        btn._originalText = btn.textContent;
      }
      btn.disabled = true;
      btn.textContent = 'Adding...';
    });

    // Add items to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart add response:', data);
      
      if (data.status === 422) {
        throw new Error(data.description || 'Unable to add items to cart');
      }
      
      // Success - trigger cart drawer and clear selection
      console.log('Cart add successful');
      
      setTimeout(() => {
        triggerCartDrawer();
        
        // Clear selected upsells after cart drawer opens
        setTimeout(() => {
          window.selectedUpsells = [];
          saveToStorage();
          updateUpsellCardStates();
          updateTotalCountDisplay();
          console.log('Selected upsells cleared after cart drawer opened');
        }, 1000);
      }, 300);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      alert('Error adding to cart: ' + error.message);
    })
    .finally(() => {
      // Always reset buttons when request completes
      resetCartButton();
      
      // Additional safety: ensure buttons are reset after 5 seconds no matter what
      setTimeout(() => {
        const allButtons = qsa('#AddToCart, #StickyAddToCart');
        allButtons.forEach(btn => {
          if (btn.disabled || btn.textContent === 'Adding...') {
            console.log('Safety timeout: forcing button reset');
            resetCartButton();
          }
        });
      }, 5000);
    });
  }

  function resetCartButton() {
    window.upsellCartInProgress = false;
    
    // Reset all add to cart buttons
    const allButtons = qsa('#AddToCart, #StickyAddToCart');
    allButtons.forEach(btn => {
      btn.disabled = false;
      // Restore original text that we saved earlier
      if (btn._originalText) {
        btn.textContent = btn._originalText;
        // Don't delete it - keep it for next time
      } else {
        // Fallback if we somehow didn't save the text
        btn.textContent = 'Add to Cart';
      }
    });
    
    console.log('Reset all add to cart buttons');
  }

  function triggerCartDrawer() {
    console.log('Attempting to trigger cart drawer...');
    
    // First, refresh the cart to ensure it has the latest items
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart refreshed, item count:', cart.item_count);
        console.log('Cart items:', cart.items.map(item => ({ title: item.title, quantity: item.quantity })));
        
        // Try multiple approaches to refresh the cart UI
        refreshCartUI(cart);
        
        // Small delay to let the cart UI update, then open drawer
        setTimeout(() => {
          openCartDrawer();
        }, 400); // Increased delay
      })
      .catch(error => {
        console.error('Error refreshing cart:', error);
        // Still try to open drawer even if refresh fails
        openCartDrawer();
      });
  }

  function refreshCartUI(cart) {
    console.log('Refreshing cart UI...');
    
    // Try multiple approaches to refresh the cart
    const refreshMethods = [
      // Method 1: Dispatch comprehensive cart events
      () => {
        const cartEvents = [
          'cart:updated', 'cart:refresh', 'cart:change', 'cartUpdated',
          'cart-drawer:refresh', 'sidebar-cart:refresh', 'drawer:refresh',
          'theme:cart:updated', 'shopify:cart:updated'
        ];
        cartEvents.forEach(eventName => {
          document.dispatchEvent(new CustomEvent(eventName, { 
            detail: cart,
            bubbles: true 
          }));
          document.body.dispatchEvent(new CustomEvent(eventName, { 
            detail: cart,
            bubbles: true 
          }));
          window.dispatchEvent(new CustomEvent(eventName, { 
            detail: cart,
            bubbles: true 
          }));
        });
      },
      
      // Method 2: Try theme-specific refresh methods
      () => {
        if (window.theme?.cart?.refresh) {
          console.log('Calling theme.cart.refresh()');
          window.theme.cart.refresh();
        }
        if (window.theme?.cartDrawer?.refresh) {
          console.log('Calling theme.cartDrawer.refresh()');
          window.theme.cartDrawer.refresh();
        }
        if (window.theme?.sidebar?.refresh) {
          console.log('Calling theme.sidebar.refresh()');
          window.theme.sidebar.refresh();
        }
      },
      
      // Method 3: Update cart count elements directly
      () => {
        if (cart && cart.item_count !== undefined) {
          const countSelectors = [
            '.cart-count', '.cart-count-bubble', '[data-cart-count]',
            '.header__cart-count', '#cart-count', '.cart-icon-count'
          ];
          
          countSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            elements.forEach(el => {
              el.textContent = cart.item_count;
              console.log(`Updated ${selector} to ${cart.item_count}`);
            });
          });
        }
      }
    ];

    // Execute all refresh methods
    refreshMethods.forEach((method, index) => {
      try {
        console.log(`Executing refresh method ${index + 1}...`);
        method();
      } catch (error) {
        console.log(`Refresh method ${index + 1} failed:`, error);
      }
    });
  }

  function openCartDrawer() {
    console.log('Opening cart drawer...');
    
    // First, let's see what's available in the global scope
    console.log('Available theme objects:', {
      theme: typeof window.theme,
      themeCart: typeof window.theme?.cart,
      Shopify: typeof window.Shopify,
      cart: typeof window.cart
    });
    
    // Log any theme-specific objects
    if (window.theme) {
      console.log('Theme object properties:', Object.keys(window.theme));
    }
    
    // Common cart drawer triggers for Shopify themes
    const cartTriggers = [
      // Try to find and click cart drawer triggers
      () => {
        const cartTriggers = [
          '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]',
          '.cart-drawer-toggle',
          '.cart-icon',
          '.header__cart-icon',
          '.cart-count-bubble',
          '[data-cart-drawer]',
          '.js-cart-drawer-toggle',
          '[href="/cart"]:not([target="_blank"])'
        ];
        
        for (const selector of cartTriggers) {
          const element = document.querySelector(selector);
          if (element) {
            console.log(`Found cart trigger element: ${selector}`, element);
            element.click();
            return true;
          }
        }
        return false;
      },
      
      // Focal theme specific methods
      () => {
        if (window.theme?.cart?.open) {
          console.log('Trying theme.cart.open()');
          window.theme.cart.open();
          return true;
        }
        return false;
      },
      
      () => {
        if (window.theme?.cartDrawer?.open) {
          console.log('Trying theme.cartDrawer.open()');
          window.theme.cartDrawer.open();
          return true;
        }
        return false;
      },
      
      // Generic Shopify cart events
      () => {
        console.log('Dispatching cart events...');
        const events = ['cart:open', 'cart-drawer:open', 'theme:cart:open', 'sidebar:open', 'drawer:open'];
        events.forEach(eventName => {
          document.dispatchEvent(new CustomEvent(eventName));
          document.body.dispatchEvent(new CustomEvent(eventName));
        });
        return false; // Can't verify if this worked
      },
      
      // Check for specific Focal drawer elements
      () => {
        const drawerElements = [
          '#sidebar-cart',
          '.drawer--cart',
          '.cart-drawer',
          '[data-drawer="cart"]'
        ];
        
        for (const selector of drawerElements) {
          const drawer = document.querySelector(selector);
          if (drawer) {
            console.log(`Found cart drawer: ${selector}`, drawer);
            
            // Try to open it by adding active/open classes
            drawer.classList.add('drawer--open', 'is-open', 'active', 'open');
            
            // Try to trigger a click on it
            if (drawer.click) {
              drawer.click();
            }
            
            return true;
          }
        }
        return false;
      }
    ];

    // Try each trigger method
    let triggered = false;
    for (let i = 0; i < cartTriggers.length; i++) {
      try {
        console.log(`Trying cart trigger method ${i + 1}...`);
        const result = cartTriggers[i]();
        if (result) {
          console.log(`Successfully triggered cart drawer with method ${i + 1}`);
          triggered = true;
          break;
        }
      } catch (error) {
        console.log(`Cart trigger method ${i + 1} failed:`, error.message);
      }
    }

    // Fallback: redirect to cart if nothing worked
    if (!triggered) {
      console.log('Could not trigger cart drawer, falling back to redirect');
      setTimeout(() => {
        window.location.href = '/cart';
      }, 1000);
    }
  }

  function wireQuantityControls() {
    const quantityInput = qs(".quantity-selector__input");
    if (quantityInput) {
      const updateQuantity = () => {
        updateTotalCountDisplay();
      };
      
      quantityInput.removeEventListener("input", updateQuantity);
      quantityInput.removeEventListener("change", updateQuantity);
      quantityInput.addEventListener("input", updateQuantity);
      quantityInput.addEventListener("change", updateQuantity);

      const quantityButtons = qsa(".quantity-selector__button");
      quantityButtons.forEach(button => {
        button.addEventListener("click", () => {
          setTimeout(updateQuantity, 10);
        });
      });
    }
  }

  function wireAddToCartButton() {
    // Wire both the standard and sticky add to cart buttons to include upsells
    const addToCartButtons = ['#AddToCart', '#StickyAddToCart'];
    
    addToCartButtons.forEach(selector => {
      const button = document.querySelector(selector);
      if (button) {
        console.log(`Found ${selector} button, intercepting for upsells`);
        
        // Remove any existing listener to prevent duplicates
        button.removeEventListener('click', handleAddToCartClick, true);
        
        // Add the listener with capture phase
        button.addEventListener('click', handleAddToCartClick, true);
        
        // Mark as wired
        button._upsellWired = true;
        
        console.log(`Successfully wired ${selector} button`);
      } else {
        console.log(`${selector} button not found in DOM`);
      }
    });
  }
  
  function handleAddToCartClick(e) {
    console.log('Add to cart clicked:', e.target.id || e.target.className);
    console.log('Selected upsells:', window.selectedUpsells);
    console.log('Number of selected upsells:', window.selectedUpsells?.length || 0);
    
    // If there are selected upsells, prevent default and use our custom function
    if (window.selectedUpsells && window.selectedUpsells.length > 0) {
      console.log('Intercepting add to cart for upsells');
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      addUpsellToCart();
      return false;
    }
    console.log('No upsells selected, allowing normal add to cart');
    // Otherwise, let the normal add to cart proceed
  }

  /*** Main initialization ***/
  function init() {
    console.log('Initializing upsell functionality...');
    
    // Only initialize if upsell wrapper exists
    if (!document.querySelector('#upsell-products-wrapper')) {
      console.log('Not an upsell product page, skipping initialization');
      return;
    }
    
    // Reset any stuck state
    window.upsellCartInProgress = false;
    
    loadFromStorage();
    
    // Wait for DOM to be fully ready
    setTimeout(() => {
      updateTotalCountDisplay();
      updateUpsellCardStates();
    }, 50);
    
    wireUpsellCards();
    wireQuantityControls();
    wireAddToCartButton();
    
    // Watch for the sticky button being added dynamically
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // Check if the added node is or contains the sticky button
            if (node.id === 'StickyAddToCart' || node.querySelector('#StickyAddToCart')) {
              console.log('Sticky button detected, wiring it up for upsells');
              setTimeout(() => {
                wireAddToCartButton();
              }, 100);
            }
          }
        });
      });
    });
    
    // Start observing the document body for added nodes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Periodically check for sticky button and ensure it's wired
    setInterval(() => {
      const stickyButton = document.querySelector('#StickyAddToCart');
      if (stickyButton && !stickyButton._upsellWired) {
        console.log('Found unwired sticky button, wiring it up');
        wireAddToCartButton();
      }
    }, 1000);
    
    // Listen for variant changes to re-wire button
    document.addEventListener('variant:change', function(event) {
      console.log('Variant changed, re-wiring add to cart button for upsells');
      setTimeout(() => {
        wireAddToCartButton();
      }, 100);
    });
    
    console.log('Upsell initialization complete');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinitialize on page visibility change
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      console.log('Page became visible, checking upsell state...');
      setTimeout(() => {
        updateUpsellCardStates();
      }, 100);
    }
  });
})();